import { ActionIcon, Text, Paper, Group, Grid, Modal } from '@mantine/core';
import { useLoans } from '@/hooks/use-loans';
import { LoansListPanel } from './loans-list-panel';
import { LoanDetailsPanel } from './loan-details-panel';
import { IconListDetails } from '@tabler/icons-react';

function ParsingResultsContent() {
  const { filteredLoans, totalCombinedLoansCount, isMobile, modalOpen, setModalOpen } = useLoans();

  return (
    <Paper radius="md" h="100%" style={{ display: 'flex', flexDirection: 'column' }} p={0}>
      <Group gap="xl" pt="lg" pb="sm" px="md">
        <Text size="sm" c="dimmed">
          Showing {filteredLoans.length} of {totalCombinedLoansCount} loans (TBD - what to do with
          manual loans here)
        </Text>
        <ActionIcon ml="auto">
          <IconListDetails />
        </ActionIcon>
      </Group>

      <Grid
        gutter="xs"
        p={0}
        style={{ flex: 1, minHeight: 0, height: '100%' }}
        styles={{ inner: { height: '100%', width: '100%' } }}
      >
        {/* Loans List Panel - Full width */}
        <Grid.Col
          span={isMobile ? 12 : 7}
          style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
          p={0}
        >
          <LoansListPanel />
        </Grid.Col>

        {/* Loan Details Panel - Only shown on desktop */}
        {!isMobile && (
          <Grid.Col
            p={0}
            span={5}
            h="100%"
            style={{
              background: 'var(--mantine-color-body)',
              padding: 'var(--mantine-spacing-md)',
            }}
          >
            <LoanDetailsPanel />
          </Grid.Col>
        )}
      </Grid>

      {/* Modal for mobile */}
      <Modal
        opened={!!(isMobile && modalOpen)}
        onClose={() => {
          setModalOpen(false);
        }}
        title="Loan history"
        fullScreen={isMobile}
        styles={{
          body: { height: 'calc(100vh - 60px)', display: 'flex', flexDirection: 'column' },
        }}
      >
        <LoanDetailsPanel />
      </Modal>
    </Paper>
  );
}

export function ParsingResults() {
  return <ParsingResultsContent />;
}
